import { render } from "./ButtonMain.vue?vue&type=template&id=9cfe95e2&scoped=true"
import script from "./ButtonMain.vue?vue&type=script&lang=js"
export * from "./ButtonMain.vue?vue&type=script&lang=js"

import "./ButtonMain.vue?vue&type=style&index=0&id=9cfe95e2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfe95e2"]])

export default __exports__